var map = {
	"./44dc1f47393655.58823b49e737b.mp4": 357,
	"./Quit Watch Dogs GIF by Ubisoft Canada.mp4": 134,
	"./Video Games Loop GIF by Johnny2x4.mp4": 557,
	"./deadsec.mp4": 517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 989;